<template>
	<div>
		<div class="top">
			<div style="font-size:42px;color:#fff">{{datainfo.product.name}}</div>
			<div style="font-size:22px;color:#fff;margin: 20px 0 50px;">{{datainfo.product.name_content}}</div>
			<el-button type="success" style="width: 180px" @click="toinfo">进入<i class="el-icon-right"></i></el-button>
		</div>
		<div class="about" v-if="datainfo.details.length > 0">
			<div style="font-size:36px;text-align:center;margin-bottom: 70px;">关于超市超级数据库</div>
			<div class="u-flex u-row-around">
				<div class="data" v-for="(item,index) in datainfo.details" :key="index">
					<div style="font-size:28px">{{item.title}}<img src="../assets/login/title.png" alt="" style="width:25px;height:20px;vertical-align:middle"></div>
					<div style="font-size:18px;color:#888888;margin-top: 10px;">{{item.title}}</div>
				</div>
			</div>
		</div>
		<div class="product" v-if="datainfo.hig.length > 0">
			<div style="font-size:36px;text-align:center;margin-bottom: 40px;">产品亮点</div>
			<div class="u-flex u-row-around">
				<div class="productItem" v-for="(item,index) in datainfo.hig" :key="index" @click="towenzhang(item)">
					<div style="font-size:28px;width: 420px;height: 274px;">
						<img :src="item.show_image" alt="" style="width:100%;height:100%">
					</div>
					<div style="font-size:18px;color:#222;padding: 32px 20px;">
						<div style="font-size:26px">{{item.title}}</div>
						<div style="font-size:20px;margin-top: 18px;" v-html="item.content"></div>
					</div>
				</div>
			</div>
		</div>
		<Bottom />

	</div>
</template>

<script>
	import Bottom from './Bottom.vue';

	export default {
		data(){
			return{
				datainfo:{
					details:[],
					hig:[],
					product:{},
					userdata:{}
				}
			}
		},
		components: {
			Bottom
		},
		watch:{
			$route(){
				this.getdata()
			}
		},
		created() {
			this.getdata()
			this.getuser();
		},
		methods:{
			getuser() {
        this.$http({
          url: "/api/Login/getUserInfo",
        }).then((res) => {
          if (res.code == 1) {
            this.userdata = res.data;
          }
        });
      },
			towenzhang(item){
				this.$router.push({
					path:"/wenzhang1",
					query:{
						id:item.id
					}
				})
			},
			toinfo(){
				if(window.localStorage.token){
					if(this.$route.query.active.split("-")[1] == 1){
						this.$router.push({
							path:"/shujuku"
						})
					}else if(this.$route.query.active.split("-")[1] == 2){
						this.$router.push({
							path:"/yiliao"
						})
					}else if(this.$route.query.active.split("-")[1] == 3){
						if(this.userdata.vip_level==0){
          this.$message.error('请先开通会员');
          return
        }
						this.$router.push({
							path:"/companyData"
						})
					}
					else{
						this.$message.error("暂未开放")
					}
				}else{
					this.$message.error("请登录")
				}
			},
			getdata(){
				this.$http({
					url: '/api/Product/productDetails',
					data:{
						id:this.$route.query.active.split("-")[1]
					}
				}).then(res => {
					this.datainfo = res.data
				})
			}
		}
	}
</script>

<style lang="scss">
	.productItem {
		width: 420px;
		height: 520px;
		background: #FFFFFF;
		box-shadow: 0px 2px 16px 0px rgba(28, 106, 255, 0.0800);
		border-radius: 10px;
	}

	.product {
		box-sizing: border-box;

		padding-top: 40px;
		width: 100%;
		height: 710px;
		background-color: #F5F6F9;
		color: #222222;
	}

	.data {
		width: 320px;
		height: 250px;
		background: #FCFDF9;
		border-radius: 10px;
		border: 1px solid #51BA85;
		padding: 20px;
		box-sizing: border-box;

	}

	.about {
		box-sizing: border-box;

		padding-top: 40px;
		width: 100%;
		height: 480px;
		background-color: #fff;
		color: #222222;
	}

	.top {
		box-sizing: border-box;
		padding: 280px 0 0 260px;
		width: 100%;
		height: 690px;
		//   background: url(../assets/login/bg.png) no-repeat;
		background-color: #000;
		background-size: 100% 100%;
	}
</style>
